
jQuery(document).on('ready', function () {

    let $ = jQuery;
    $("header .header-menu-nav-toggle").on("click", function() {
        $('.slide-in-nav').addClass('active');
    });

    $("header .slide-in-nav .nav-close").on("click", function () {
        $('.slide-in-nav').removeClass('active');
    })

    $('header .nav-links .menu-item-has-children a.dropdown-toggler').on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).parent('li').toggleClass('sub-menu-active');
        let $submenu = $(this).parent('li').children('.sub-menu');
        $submenu.slideToggle(500);
        $submenu.addClass('active');
    });

    $('.sidebar-navigation .menu .page_item_has_children a').on("click", function(e) {
        if($(this).parent('li').children('ul').length !== 0) {
            e.preventDefault();
            e.stopPropagation();
            $(this).parent('li').toggleClass('sub-menu-active');
            let $submenu = $(this).parent('li').children('ul');
            $submenu.slideToggle(500);
            $submenu.addClass('active');
        }
    });

});